module.exports = __webpack_public_path__ + "img/log-out.da8bc53b.svg";